import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 350,
    height: 350,
    padding: 40,
    margin: "100px 20px 0",
    background: "#bbb"
  },
  media: {
    width: "100%",
    height: "180px",
    border: "1px solid #888"
  },
  content: {
    padding: "20px 0"
  }

}));

export default function Front() {
  const classes = useStyles();

  return (
    <Grid container style={{ alignItems: 'center', justifyContent: 'center' }}>
      <Card className={classes.root}>
        <Grid className={classes.grid}>
          <img className={classes.media}
            src="/img/reklam1.png"
            alt=""
          />
          <CardContent className={classes.content}>
            <Typography variant="body2" color="textSecondary" component="p">
              Ut nibh nunc, sollicitudin nec suscipit id, volutpat sed nibh. Donec vitae luctus orci.         </Typography>
          </CardContent>
        </Grid>
      </Card>

      <Card className={classes.root}>
        <Grid>
          <img className={classes.media}
            src="/img/reklam5.png"
            alt=""
          />
          <CardContent className={classes.content}>
            <Typography variant="body2" color="textSecondary" component="p">
              Fusce ut felis ipsum. Aliquam lacinia justo nec lectus fringilla consectetur. Nulla non lacus ac est viverra bibendum.
            </Typography>
          </CardContent>
        </Grid>
      </Card>

      <Card className={classes.root}>
        <Grid>
          <img className={classes.media}
            src="/img/reklam3.png"
            alt=""
          />
          <CardContent className={classes.content}>
            <Typography variant="body2" color="textSecondary" component="p">
              Etiam a dignissim lacus. Nullam ante urna, malesuada non placerat sed, eleifend vel nibh.
            </Typography>
          </CardContent>
        </Grid>
      </Card>
    </Grid>
  );
}